import color from '@theme/Colors';

export const getHighlightColor = (condition: boolean): string => {
    return condition ? color.danger : color.textPrimary;
};

export const MQTTConfigExpectValue = (devMac?: string) => {
    return {
        SnapshotTopic: '4GSolarCam/Snapshot',
        StatusTopic: '4GSolarCam/Status',
        AlarmTopic: '4GSolarCam/Alarm',
        ConfigRequestTopic: `4GSolarCam/Api/${devMac}`,
        ConfigResponseTopic: '4GSolarCam/Api',
    };
};
